import * as components from './components';

export default [
  {
    path: '/masters/service-companies',
    component: components.ServiceCompanyList,
    name: 'serviceCompanyList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/servicecompanies/routes.js